import {createContext} from 'react';
import { IProviderState } from '../IDocInterfaces';

const DocContext = createContext<IProviderState>({} as IProviderState);

export default DocContext;
